import { render, staticRenderFns } from "./customer-icon.vue?vue&type=template&id=9ad8ea6a&scoped=true"
import script from "./customer-icon.vue?vue&type=script&lang=ts"
export * from "./customer-icon.vue?vue&type=script&lang=ts"
import style0 from "./customer-icon.vue?vue&type=style&index=0&id=9ad8ea6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad8ea6a",
  null
  
)

export default component.exports